const VALUE_PATTERN = /^(\d{4}-\d{2}-\d{2})(?:[T ](\d{2}:\d{2}))?/;

export type ParsedDateTimeValue = {
  date?: string;
  time?: string;
};

// A stored booking value may be a plain date ("2027-01-14") for records
// saved before a time became a required field — the time group is optional,
// so a legacy date-only value still parses to a valid date with no time,
// never throwing or producing an invalid result.
export const parseDateTimeValue = (value?: string): ParsedDateTimeValue => {
  const match = VALUE_PATTERN.exec(value?.trim() ?? '');

  return { date: match?.[1], time: match?.[2] };
};
